<!-- State: All Non-Game Screens Layout -->
<div class="wrapper-container scene-background" [class.city-scene]="useCityBackground()">

	<!-- Background scene - positioned absolutely behind content -->
	<div class="absolute top-0 left-0 w-full h-[screen] z-0 overflow-hidden">

		@if (useCityBackground()) {
		<!-- City background for myprizes and myavatar -->
		<div class="city-sky h-[600px] relative"></div>
		<div class="city-ground h-[300px]"></div>
		} @else {
		<!-- Nature background for other routes -->
		<div class="nature-sky relative" [style.height]="getNatureSkyHeight()">
			<!-- Skyline background - positioned behind nature-ground, in front of nature-sky, behind clouds -->
			<div class="nature-skyline-background"></div>
			<!-- Simple CSS cloud animation -->
			<div class="cloud cloud-1"></div>
			<div class="cloud cloud-2"></div>
			<div class="cloud cloud-3"></div>
			<div class="cloud cloud-4"></div>
		</div>
		<div class="nature-ground h-[300px]">
			<!-- Scene Nature Background -->
			<div class="scene-nature-background"></div>
		</div>
		}

	</div>

	<!-- Responsive Content Container -->
	<div class="relative z-10 max-w-md w-full mx-auto flex-1 flex flex-col">
		<router-outlet />
	</div>

	<!-- Navigation and Footer Wrapper -->
	<div class="sticky bottom-0 z-20 w-full bg-[#313133]">
		<!-- Navigation - Sticky above footer -->
		@if (authService.user()) {
		<div class="w-full bg-[#333639] pixel-nav-border">
			<nav class="max-w-md w-full mx-auto pt-8 pb-4 px-4">
				<div class="flex flex-col xs:flex-row justify-center gap-4 xs:gap-8 text-sm">
					<a routerLink="/app/home" routerLinkActive="active" class="nav-link pixel-nav">
						PLAY&#x2002;&&#x2002;WIN
						<arrow-icon class="nav-arrow" color="#BDBDBD" [size]="8"></arrow-icon>
					</a>
					<a routerLink="/app/myprizes" routerLinkActive="active" class="nav-link pixel-nav">
						MY&#x2002;PRIZES
						<arrow-icon class="nav-arrow" color="#BDBDBD" [size]="8"></arrow-icon>
					</a>
					<a routerLink="/app/myavatar" routerLinkActive="active" class="nav-link pixel-nav">
						MY&#x2002;AVATAR
						<arrow-icon class="nav-arrow" color="#BDBDBD" [size]="8"></arrow-icon>
					</a>
				</div>
			</nav>
		</div>
		}

		<!-- Footer - Sticky at bottom -->
		<div class="w-full bg-[#313133]" [class.pt-4]="!authService.user()">
			<footer class="max-w-md w-full mx-auto py-8 px-4">
			<div class="flex flex-col xs:flex-row items-center xs:items-start justify-between">
				<!-- CRUST™ Logo -->
				<div class="mb-6 xs:mb-0">
					<a href="https://www.crust.com.au/" target="_blank"><crust-logo [color]="'#4D4D4D'"
							[size]="'h-6 w-auto'"></crust-logo></a>
				</div>

				<!-- Footer Links -->
				<div class="flex flex-col xs:flex-row gap-6 items-center xs:items-start">
					<!-- Left Column -->
					<div class="flex flex-col gap-2 items-center xs:items-start text-center xs:text-left">
						<a href="https://www.crust.com.au/" target="_blank"
							class="pixel-footer-link inline-flex items-center gap-1">
							Order&#x2002;Online
							<external-link-icon [color]="'currentColor'" [size]="14"></external-link-icon>
						</a>
						<a href="https://www.crust.com.au/users/sign_up" target="_blank"
							class="pixel-footer-link inline-flex items-center gap-1">
							Rewards
							<external-link-icon [color]="'currentColor'" [size]="14"></external-link-icon>
						</a>
						<a href="https://www.crust.com.au/aboutus/contact" target="_blank"
							class="pixel-footer-link inline-flex items-center gap-1">
							Contact&#x2002;Us
							<external-link-icon [color]="'currentColor'" [size]="14"></external-link-icon>
						</a>
					</div>

					<!-- Right Column -->
					<div class="flex flex-col gap-2 text-center xs:text-left">
						<a routerLink="/" class="pixel-footer-link">Home</a>
						@if (authService.user()) {
						<a routerLink="/app/home" class="pixel-footer-link">Play&#x2002;&&#x2002;Win</a>
						<a routerLink="/app/myprizes" class="pixel-footer-link">My&#x2002;Prizes</a>
						<a routerLink="/app/myavatar" class="pixel-footer-link">My&#x2002;Avatar</a>
						<a (click)="signOut()" class="pixel-footer-link">Sign&#x2002;Out</a>
						} @else {
						<a routerLink="/auth/login" class="pixel-footer-link">Sign&#x2002;In</a>
						}
						<a href="#" class="pixel-footer-link">T&Cs</a>
					</div>
				</div>
			</div>

			<!-- Copyright -->
			<div class="text-center text-xs text-[#4D4D4D] mt-8 pt-6 border-t border-[#4D4D4D]">
				<heart-icon [color]="'#4D4D4D'" [size]="22"
					(click)="toggleCrt(); toggleNavTextShadow()"></heart-icon>&#x2002;from&#x2002;CRUST™&#x2002;{{
				currentYear }}
			</div>
		</footer>
		</div>
	</div>

</div>